export const MESSAGE_TYPE_START = 'start';
export const MESSAGE_TYPE_UPLOADED = 'uploaded';
export const MESSAGE_TYPE_ERROR = 'error';
export const MESSAGE_TYPE_PROGRESS = 'message';
